export const cmpId = 'twitch';